
export const InitializeWineSearchResults = (argument) => ({
    type: 'INITIALIZE_WINE_SEARCH_RESULTS',
    payload: {
      sortBy: argument.sortBy,
      activeMenu: argument.activeMenu
    },
  });
